import { QueryClientProvider } from "@tanstack/react-query";
import { createRouter, RouterProvider } from "@tanstack/react-router";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { ErrorState } from "./components/error-state";
import { Spinner } from "./components/spinner";
import { initMonitoring } from "./lib/monitoring";
import { createQueryClient } from "./lib/query-client";
import { tools } from "./lib/tools";
import { routeTree } from "./routeTree.gen";
import "./styles.css";

void initMonitoring();

const queryClient = createQueryClient();

const router = createRouter({
  routeTree,
  context: { queryClient, tools },
  defaultPreload: "intent",
  defaultPendingComponent: Spinner,
  defaultErrorComponent: ErrorState,
  // Loaders already run through the query cache; don't double-fetch.
  defaultPreloadStaleTime: 0,
  scrollRestoration: true,
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("#root missing from index.html");

createRoot(rootEl).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);
